import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LandingScreen } from '@/routes/Landing';

const HostRoutes = lazy(() => import('@/routes/host'));
const ContributorScreen = lazy(() => import('@/routes/c/ContributorScreen'));
const PlayRoutes = lazy(() => import('@/routes/play'));
const KioskScreen = lazy(() => import('@/routes/kiosk/KioskScreen'));
const ControlScreen = lazy(() => import('@/routes/control/ControlScreen'));

function RouteFallback() {
  return (
    <div className="min-h-screen grid place-items-center bg-paper text-ink">
      <div className="chunky px-6 py-4 display font-display font-bold animate-floaty">Loading…</div>
    </div>
  );
}

export function AppRouter() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<LandingScreen />} />
        <Route path="/host/*" element={<HostRoutes />} />
        <Route path="/c/:token" element={<ContributorScreen />} />
        <Route path="/play/*" element={<PlayRoutes />} />
        <Route path="/kiosk/:token" element={<KioskScreen />} />
        <Route path="/control/:token" element={<ControlScreen />} />
      </Routes>
    </Suspense>
  );
}
